import { UseCase } from '@/core/base/use-case';
import { Observable } from 'rxjs';
import { RefundPolicyResponse } from '../models/refund-policy-response.model';
import { RefundPolicyRepository } from '../repositories/refund-policy.respository';

export class GetRefundPolicyUseCase
    implements UseCase<never, RefundPolicyResponse>
{
    constructor(private readonly repository: RefundPolicyRepository) {}

    execute(): Observable<RefundPolicyResponse> {
        return this.repository.getRefundPolicy();
    }
}
